import React from 'react'
import moment from 'moment'
import _ from 'underscore'
import numeral from 'numeral'
import AutoComplete from '../components/react-autocomplete'
import NumericTextBox from '../components/react-numerictextbox'
import { format } from "d3-format"
import { timeFormat } from "d3-time-format"
import { ChartCanvas, Chart, series, scale, coordinates, tooltip, annotation, axes, helper } from "react-stockcharts"


var { BarSeries, LineSeries, AreaSeries, ScatterSeries, CircleMarker } = series;
var { discontinuousTimeScaleProvider } = scale;
var { Annotate, LabelAnnotation, Label } = annotation;
var { CrossHairCursor, MouseCoordinateX, MouseCoordinateY } = coordinates;

var { OHLCTooltip } = tooltip;
var { XAxis, YAxis } = axes;
var { fitWidth } = helper;


export default class PositionWidget extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			savedLayout : props.savedLayout || {},
			symbol : '',
			quote : {},
      positionKeyId : 0,
			quantity : 0,
      data: [{close: 100, open: 100, high: 100, low: 100,date:new Date(2016, 11, 6) },{close: 110 , open: 100, high: 100, low: 100 , date:new Date(2016, 11, 7) }],
      width: 600,
      height: 300,
      ratio: 1,
      type: "svg",
		}
    // websocket connections
    this.sockets = []
	}

	saveLayout() {
		if (window.updateLayout) {
			if (this.state.symbol)
				window.updateLayout({
					symbol : this.state.symbol,
				})
		}
	}

	updateTitle() {
		console.log("updateTitle");
		let description = this.props.description + ' - ' + this.props.book + '/' + this.props.tag + ' Quantity: ' + numeral(this.props.quantity).format('0,0') + ' Unit Cost: ' + numeral(this.props.unit_cost).format('0,0.00')  || ''

		if (this.props.onTitle) {
			this.props.onTitle(description)
		}
	}

	componentDidMount() {
    console.log("componentDidMount ");

    // subscribe to realtime Feed
    realtime().then( (socket) => {
		this._socket = socket
		socket.onclose = (e) => {
			if (e.wasClean != true)
				raiseAlert("CONNECTION LOST: " + e.code + " " + e.reason)
		}
		socket.onjson = (message) => {
			if (message.op == "_queryPL") {
          		console.log("_queryPL");
				let result = []
				try {
					result = JSON.parse(message.result)
				} catch(e) { console.log(e, m.data); return; }

				if (message.cid == "POSITION_PL_TS") {

              		console.log(result);
					// console.log("fundSummary ==> ", result)
					if (result.length > 1) {
						result.forEach((d, i) => {
							d.date = new Date(d.date);
							d.open = +d.open;
							d.high = +d.high;
							d.low = +d.low;
							d.close = +d.close;
								// console.log(d);
						});
						this.setState({
									loaded : true,
									data : result
								},
								() => {
								// this.refs.summaryWidget.classList.add("loaded")
								})
					}
					return
				}
			}
		}

		this.state.positionKeyId = this.props.position_key; //vodafone
		this._socket.send(JSON.stringify({
          op : "_queryPL",
          cid: "POSITION_PL_TS",
          sql : `SELECT
                     update_time AT TIME ZONE 'UTC' AS date,
                     price     AS close,
                     price     AS open,
                     price     AS high,
                     price     AS low
                  FROM position_tdy_pl_ts
                  WHERE position_key_id = ${this.state.positionKeyId}
									AND update_time > current_date + interval '8 hours'
                  ORDER BY update_time`,
      	}))

		this.updateTitle()
    	//  this.state.data = POSITION_PL_TS;
    	//  console.log(POSITION_PL_TS);
	}).catch((err) => { console.log(err) }) // end of subscribe to realtime Feed

    //layout
    if (this.props.onResize)
      this.props.onResize(650,325)

    	//load from saved state
			let savedSymbol = this.state.savedLayout.symbol || this.props.symbol
    	if (savedSymbol) {
          }

	}

	componentWillUnmount() {
    if (this._socket) this._socket.close()
	}

    render() {
    console.log("rendering ", this.state);

		var gridHeight = this.state.height - 20 - 20;
		var gridWidth = this.state.width - 50 - 50;

		var showGrid = true;
		var yGrid = showGrid ? { innerTickSize: -1 * gridWidth, tickStrokeOpacity: 0.2 } : {};
		var xGrid = showGrid ? { innerTickSize: -1 * gridHeight, tickStrokeOpacity: 0.2 } : {};

  		return (
				<div >
  			<ChartCanvas ratio={1} width={this.state.width} height={this.state.height}
  					margin={{left: 50, right: 50, top:20, bottom: 20}} type={"hybrid"}
  					seriesName={this.props.symbol}
  					data={this.state.data}
  					xAccessor={d => d.date} xScaleProvider={discontinuousTimeScaleProvider}
  					xExtents={[this.state.data[0].date, this.state.data[this.state.data.length -1].date]}>
  				<Chart id={1}
  						yExtents={d => [d.high, d.low]}>
  					<XAxis axisAt="bottom" orient="bottom" stroke="#FFFFFF" tickStroke="#FFFFFF" fontSize="10" {...xGrid} />
  					<YAxis axisAt="right" orient="right" ticks={10} tickStroke="#FFFFFF" fontSize="10" {...yGrid} />
						{/* <Label x={(this.state.width - 100) / 2} y={30}
							fontSize="15" text={this.props.symbol} fontColor="green"/> */}
  					<MouseCoordinateX
  						at="bottom"
  						orient="bottom"
  						// displayFormat={timeFormat("%Y-%m-%d:%H:%M")} />
							displayFormat={timeFormat("%H:%M")} />
  					<MouseCoordinateY
  						at="right"
  						orient="right"
  						displayFormat={format(".2f")} fontSize="10"/>
  					<LineSeries yAccessor={d => d.close} />
  					{/* <ScatterSeries yAccessor={d => d.close} marker={CircleMarker} markerProps={{ r: 1 }} /> */}
  					{/* <OHLCTooltip forChart={1} origin={[-40, 0]}/> */}
						{/* <Title forChart={1} origin={[-40, 0]} /> */}
  				</Chart>
					<CrossHairCursor strokeDasharray="LongDashDot" stroke="orange"/>
  			</ChartCanvas>
			</div>
  		);
  }
}

  PositionWidget.propTypes = {

  };

  PositionWidget.defaultProps = {
  	type: "svg",
  };

  PositionWidget = fitWidth(PositionWidget);



// WEBPACK FOOTER //
// ./src/widgets/position.jsx